import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import PageSection from '../../../PageSection'
import BarGraph from '../../../Graphs/BarGraph'

// import { ReactComponent as RiseUpIcon } from '../../../../assets/icons/rise-up-icon.svg'

import { formatNumber } from '../../../../../helpers/numbers'
import { formatSegmentLabels } from '../../helpers'

import useStyles from '../../styles'

const ConversionsGraphSection = ({ rawGraphData }) => {
  const classes = useStyles()

  const conversionsGraphData = useMemo(
    () => rawGraphData && rawGraphData.data && rawGraphData.data.map(data => data.value),
    [rawGraphData]
  )
  const conversionsGraphLabels = useMemo(() => formatSegmentLabels(rawGraphData), [rawGraphData])

  return (
    <PageSection className={classes.sectionContainer}>
      <div className={classes.headingContainer}>
        <div className={classes.title}>Conversions</div>
        <div className={classes.value}>{formatNumber(rawGraphData.total)}</div>
      </div>
      <BarGraph
        className={classes.graphWrapper}
        data={conversionsGraphData}
        labels={conversionsGraphLabels}
        format="integer"
      />
    </PageSection>
  )
}

ConversionsGraphSection.propTypes = {
  rawGraphData: PropTypes.object.isRequired
}

export default ConversionsGraphSection
